import debounce from 'lodash.debounce'

export default debounce
